<section class="v4-bg-img" [hidden]="step.value == 5">
  <div class="container">
    <section>
      <div class="d-flex justify-content-between pt-5 5555">
        <div class="d-flex">
          <img
            class="img-icon"
            src="../../../../../assets/v-4-icone/Layer-2.svg"
            alt="loading"
          />
          <h2 class="font-600 v4-color-white bottom-line p-0">
            {{ "Create a training course" | translator }}
          </h2>
        </div>
        <div class="d-flex h-fit">
          <button
            (click)="reload()"
            class="v4-btn-every py-2 d-flex align-items-center"
          >
            <i class="pi pi-arrow-left v4-ml-2"></i>{{ "Back" | translator }}
          </button>
        </div>
      </div>
      <!-- breadcrumb -->
      <div class="d-flex flex-row align-items-center flex-wrap my-3 mx-3">
        <span class="d-flex align-items-center">
          <span
            (click)="changeRoute('/home')"
            class="custom-bredcrum-btn d-flex align-items-center"
          >
            {{ "Homepage" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span
            (click)="reloadPage()"
            class="custom-bredcrum-btn d-flex align-items-center"
          >
            {{ "training courses" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
            {{ "Create a training course" | translator }}
          </span>
        </span>
      </div>
      <!-- breadcrumb end -->
    </section>
  </div>


  <!-- course creation form -->
  <div class="container max-width-900">
    <div class="row">
      <app-skelitions *ngIf="loading" [value]="3" ></app-skelitions>
      <div class="" [hidden]="loading">
        <div class="bg-white">
          <div class="d-flex justify-content-between mx-3">
            <h3 class="step">{{ "a step" | translator }} : {{ step.value }}</h3>
          </div>
          <form
            [hidden]="step.value != 1"
            [formGroup]="createCourseForm"
            (ngSubmit)="onSubmit()"
            novalidate
          >
            <div class="card-scroll">
              <div class="row">
                <div class="col-lg-12">
                  <label
                    class="block v4-color-white font-medium mb-2 font-bold"
                    for="title"
                  >
                    {{ "training name" | translator }}</label
                  >
                  <input
                    type="text"
                    id="title"
                    placeholder="{{ 'Please write the address' | translator }}"
                    formControlName="title"
                    pInputText
                    class="w-full mb-3"
                  />
                  <div
                    class="error"
                    *ngIf="
                      createCourseForm.controls['title'].invalid &&
                      (createCourseForm.controls['title'].dirty ||
                        createCourseForm.controls['title'].touched)
                    "
                  >
                    <div
                      *ngIf="createCourseForm.controls['title'].errors?.['required']"
                    >
                      {{ "Address required" | translator }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <label
                    class="block v4-color-white font-medium mb-2 font-bold"
                    for="description"
                  >
                    {{ "Description" | translator }}
                  </label>
                  <!-- <p-editor formControlName="description" [style]="{ height: '320px' }">
                  </p-editor> -->
                  <textarea
                    rows="7"
                    class="w-full mb-3"
                    [style]="{ height: '320px' }"
                    pInputTextarea
                    formControlName="description"
                  ></textarea>

                  <div
                    class="error"
                    *ngIf="
                      createCourseForm.controls['description'].invalid &&
                      (createCourseForm.controls['description'].dirty ||
                        createCourseForm.controls['description'].touched)
                    "
                  >
                    <div
                      *ngIf="createCourseForm.controls['description'].errors?.['required'] &&  createCourseForm.controls['description'].touched"
                    >
                      {{ "Description required" | translator }}
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <label
                    class="block v4-color-white font-medium mb-2 font-bold"
                    for="courseImage"
                  >
                    {{ "Image of the training course" | translator }}</label
                  >
                  <div class="d-flex justify-content-center">
                    <img
                      [hidden]="courseImage == ''"
                      class="course-img"
                      [src]="GlobalConstants.staticFilesURL + courseImage"
                    />
                  </div>
                  <!-- <p-fileUpload class="my-2 v4-calander" mode="basic" name="file" [url]="apilink + 'file/data'"
                    [auto]="true" [chooseLabel]="'Add image' | translator" accept="image/*" [maxFileSize]="10000000000"
                    (onUpload)="courseImage = $event.originalEvent.body.data"></p-fileUpload> -->

                  <app-file-upload
                    #materialUploadElem
                    (response)="materialUploadResponse($event)"
                    [imageType]="trainingMaterialImageType"
                    [accept]="'image/*'"
                  ></app-file-upload>
                </div>

                <p-divider align="left">
                  <div class="inline-flex align-items-center">
                    <i class="pi pi-calendar ml-2 mr-2"></i>
                    <b>{{ "Duration" | translator }} </b>
                  </div>
                </p-divider>

                <div class="col-lg-12">
                  <p-calendar
                    class="ppp-calander"
                    dateFormat="dd-mm-yy"
                    (onSelect)="dateValidate($event)"
                    formControlName="timeline"
                    [selectionMode]="dateType"
                    placeholder="{{ 'select date' | translator }}"
                  >
                    <ng-template pTemplate="date" let-date>
                      <span
                        [ngStyle]="{
                          textDecoration: disbleDates(date)
                            ? 'line-through'
                            : 'inherit'
                        }"
                        >{{ date.day }}</span
                      >
                    </ng-template>
                  </p-calendar>
                </div>
                <div class="error" *ngIf="invalidDate">
                  {{ invalidDate | translator }}
                  <span *ngIf="monthDateError">({{ data?.date?.id }})</span>
                </div>
                <div
                  class="error"
                  *ngIf="createCourseForm.controls['timeline'].errors?.['required'] && createCourseForm.controls['timeline'].touched"
                >
                  {{ "Date is Required" | translator }}
                </div>
              </div>
            </div>
          </form>
          <!-- End course creation form -->

          <!-- File Upload Section -->
          <section [hidden]="step.value != 1"></section>

          <div
            *ngIf="newBranchTraining && !!!this.formTrainingProgram"
            class="col-lg-12"
          >
            <div class="mx-3">
              <label
                class="block v4-color-white font-medium mb-2 font-bold"
                for="description"
              >
                {{ "Select newly created branch" | translator }}
              </label>
              <p-treeSelect
                appendTo="body"
                [(ngModel)]="selectedOus"
                class="w-md-20rem w-100"
                containerStyleClass="w-100"
                [options]="selectedTreeData"
                placeholder="حدد الوحدة التنظيمية"
                [filter]="true"
                [filterInputAutoFocus]="true"
                (onNodeSelect)="filterFunctionByPostOuFilter($event)"
              >
                <ng-template let-node pTemplate="default">
                  <div class="d-flex">
                    <img
                      *ngIf="checkisImg(node.data); else elseBlock"
                      src="{{ staticURL }}{{ node.data }}"
                      class="img-fluid p-1 tree-img-bg"
                      style="max-height: 30px; max-width: 30px"
                    />
                    <ng-template #elseBlock>
                      <i
                        class="{{ node.data }} p-2"
                        style="font-size: 1rem"
                      ></i>
                    </ng-template>
                    <b class="text-nowrap">{{ node.label }}</b>
                  </div>
                </ng-template>
              </p-treeSelect>
            </div>
          </div>

       
          <p *ngIf="message" class="message">{{ message }}</p>

          <div class="mx-3">
            <button
              [hidden]="step.value >= 3"
              type="button"
              (click)="onSubmit()"
              class="v4-btn-every w-full my-2 py-2"
            >
              <i class="pi pi-angle-double-left v4-ml-2"></i
              >{{ "the next" | translator }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="step.value == 5">
  <app-show-detail
    *ngIf="step.value == 5"
    [data]="data"
    [fromCreateTraining]="fromCreateTraining"
    [permissions]="permissions"
    [courseDetails]="completeCourseObject"
  ></app-show-detail>
</section>

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Add Trainer' | translator }}"
  [(visible)]="addTrainerModal"
  [style]="{ margin: '0rem 1rem', width: '70vw' }"
  [maximizable]="true"
>
  <ng-container *ngIf="!showInternal; else addInternalTrainer">
    <app-add-external-user
      *ngIf="addTrainerModal"
      [addCompany]="true"
      (updatedData)="handleUpdatedUserData($event)"
      [type]="'CREATE'"
      [ExternalType]="'trainer'"
    ></app-add-external-user>
  </ng-container>
  <ng-template #addInternalTrainer>
    <app-assign-users
      [userFetchUrl]="'user/get'"
      [selectionData]="[]"
      (selectedUsersList)="assNewTrainers($event)"
      [query]="{
        'externalUser.status': { $ne: true },
        'externalUser.role': { $nin: ['trainer', 'coordinator'] }
      }"
      *ngIf="showInternal"
    >
    </app-assign-users>
  </ng-template>
</p-dialog>
